var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 75,
    viewBox: "0 0 198 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.6971 0.775995H66.8531V14.096C63.1531 8.028 51.1651 0.627997 37.8451 0.627997C17.5691 0.627997 0.845124 17.352 0.845124 37.48C0.845124 57.608 17.5691 74.48 37.8451 74.48C51.1651 74.48 63.1531 66.932 66.8531 60.864V74.48H74.6971V0.775995ZM37.8451 66.636C21.5651 66.636 8.68912 53.76 8.68912 37.48C8.68912 21.348 21.5651 8.472 37.8451 8.472C53.9771 8.472 66.8531 21.348 66.8531 37.48C66.8531 53.76 53.9771 66.636 37.8451 66.636ZM172.382 0.183998C162.762 0.183998 154.03 6.4 151.366 12.32C148.702 6.4 139.97 0.183998 130.35 0.183998C122.358 0.183998 115.106 4.328 113.33 6.992L113.182 0.479999L105.338 0.627997L105.486 24.752C105.486 24.308 105.338 25.492 105.338 26.972V74.48H113.182V26.972C113.182 16.316 120.73 8.028 130.35 8.028C139.97 8.028 147.37 16.316 147.37 26.972V74.48H155.362V26.972C155.362 16.316 162.762 8.028 172.382 8.028C182.15 8.028 189.55 16.316 189.55 26.972V74.48H197.394V26.972C197.394 12.32 185.998 0.183998 172.382 0.183998Z",
    fill: "#FEC736"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAm);
export default __webpack_public_path__ + "static/media/AM.65d951a2b88bd80e9e3e456010b40d7d.svg";
export { ForwardRef as ReactComponent };